<template>
  <div>
    <el-upload
      ref="upload"
      slot="append"
      multiple
      :show-file-list="false"
      action="#"
      :disabled="isUploading"
      :auto-upload="true"
      :accept="accept"
      :http-request="upload"
    >
      <slot name="default"></slot>
    </el-upload>
    <el-dialog
      :visible.sync="isUploading"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="30%"
    >
      <p style="font-size: 16px; line-height: 1; text-align: center">
        文件上传中<i class="el-icon-loading" style="margin-left: 5px"></i>
      </p>
      <el-progress
        style="margin-top: 30px"
        :text-inside="true"
        :stroke-width="20"
        :percentage="percentage"
      ></el-progress>
    </el-dialog>
  </div>
</template>

<script>
import request from "axios";
import partUpload from "@/utils/uploadPartUtils";
export default {
  props: {
    accept: String,
    fileType: Array,
  },
  data() {
    return {
      isUploading: false,
      percentage: 0,
    };
  },
  methods: {
    upload(up) {
      const vm = this;
      if (up.file) {
        if (vm.fileType.length > 0) {
          const type = up.file.type ? up.file.type : "";
          if (!vm.format(vm.fileType, type)) {
            let tipText = vm.fileType.join("、");
            vm.$message.error(`上传文件格式不正确，请选择${tipText}格式的文件`);
            return;
          }
        }

        this.isUploading = true;
        if (up.file.size / 1024 / 1024 < 2) {
          let formData = new FormData();
          formData.append("file", up.file);
          request
            .post(`${process.env.VUE_APP_API_DOMAIN}/upload`, formData)
            .then((res) => {
              vm.percentage = 100;
              this.isUploading = false;
              vm.$emit("success", res.data.data);
              this.$emit("input", res.data.data.url);
              this.$refs.upload.clearFiles();
            });
        } else {
          const upload = partUpload({
            onUploadProgress(current) {
              vm.percentage = Math.floor(current * 100);
            },
            onUploadSucceed(file) {
              vm.$emit("input", file.url);
              vm.$emit("success", file);
              vm.$refs.upload.clearFiles();
              vm.isUploading = false;
            },
          });
          this.partUpload = upload;
          upload.addFile(up.file);
          upload.startUpload();
        }
      }
      vm.percentage = 0;
    },
    format(typeArray, currentType) {
      return typeArray.some((e) => {
        return e === currentType;
      });
    },
    handleClose(done) {
      this.$confirm("确定要取消上传吗？")
        .then((_) => {
          if (this.partUpload) {
            this.partUpload.cancelUpload();
            this.$refs.upload.clearFiles();
          }
          done();
        })
        .catch((_) => {});
    },
  },
};
</script>
